import React, { useCallback, useMemo, useState } from 'react';

import { NotificationManager, prepareRequest } from '@atlas/core';
import { onWithdrawalApexpaySubmit, PREDEFINED_FORMS } from '@atlas/react-forms';
import { parseWithdrawalQuery } from '@atlas/routing';
import { DefaultPopup, HeaderTitle, Label } from '@atlas/ui';

import FormCom from 'common/Form/FormMobile';

export const WithdrawalApexpayPopup = ({ data: { paymentMethod, redirectUrl }, id }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { amount, currency, mobileNumber } = useMemo(
    () => parseWithdrawalQuery(redirectUrl),
    [redirectUrl],
  );
  const additionalValues = useMemo(() => ({ amount, mobileNumber }), [amount, mobileNumber]);

  const handleClose = useCallback(() => NotificationManager.removeNotification(id), [id]);
  const handleSubmit = useCallback(
    async value => {
      if (isSubmitting) return;
      const request = prepareRequest({
        method: 'POST',
        url: 'payments/apexpay/payment/withdraw',
      });

      setIsSubmitting(true);

      try {
        const response = await request(value);
        NotificationManager.display({
          data: {
            amount,
            currency,
            paymentMethod,
            publicPaymentId: response?.publicPaymentId,
          },
          message: 'successfulWithdrawal',
          type: 'successfulWithdrawal',
        });
      } catch (error) {
        NotificationManager.display({
          data: {
            headerTitle: 'withdrawal_by_apexpay',
            title: 'failed_sad_emoticon',
          },
          type: 'error',
        });
      } finally {
        handleClose();
      }
    },
    [amount, currency, handleClose, isSubmitting, paymentMethod],
  );

  return (
    <DefaultPopup
      className="withdrawal-apexpay"
      headerTitle="withdrawal_by_apexpay"
      headerTitlePosition="left"
      onClose={handleClose}
    >
      <HeaderTitle className="center block-big withdrawal-apexpay__title">
        <div className="title-bold-text">
          <Label message="payment_details" />
        </div>
        <div className="sub-title-text">
          <Label message="please_fill_in_the_fields_below" />
        </div>
      </HeaderTitle>

      <div className="withdrawal-apexpay__content">
        <FormCom
          action={onWithdrawalApexpaySubmit}
          additionalValues={additionalValues}
          buttonText="withdrawal"
          disableButton={isSubmitting}
          form={PREDEFINED_FORMS.withdrawalApexpayForm}
          onSubmit={handleSubmit}
        />
      </div>
    </DefaultPopup>
  );
};
